@if (printMode) {
  <div>
    <div>
      <router-outlet></router-outlet>
    </div>
  </div>
} @else {
  <div
    class="app-container"
    [class.fullscreen]="fullscreenMode"
    [class.iris-main-menu-opened]="sidenav.opened"
  >
    @if (globalNotificationService.notificationMessage() && globalNotificationService.notificationActive()) {
      <global-announcement-banner
        [message]="globalNotificationService.notificationMessage()"
      ></global-announcement-banner>
    }
    @if (showMessage()) {
      <global-announcement-banner
        [message]="translateWarning"
      >
        <sk-button aria-label="Clear"
                   size="sm"
                   appearance="icon"
                   (click)="hideMessage()">
          <ng-template buttonPrefix>
            <i class="fa-lg fal fa-times icon"></i>
          </ng-template>
        </sk-button>
      </global-announcement-banner>
    }

    <iris-header></iris-header>

    <mat-sidenav-container class="app-wrap"
                          [autosize]="true"
                          [hasBackdrop]="navMenu.hasBackdrop"
                          (backdropClick)="navMenu.close()">
      <mat-sidenav class="app-navigation-menu-container narrow d-block" #sidenav
                  [mode]="sidenavMode"
                  [opened]="isPinned"
                  [autoFocus]="false"
                  (keydown.escape)="navMenu.close()"
                  [class.pinned]="sidenavMode === 'side'"
                  [class.over]="sidenavMode === 'over'"
                  disableClose>
        <global-navigation-menu
          #navMenu
          [(sidenavMode)]="sidenavMode"
          (sidenavModeChange)="onSidenavModeChange($event)"
        ></global-navigation-menu>
      </mat-sidenav>

      <mat-sidenav-content class="app-navigation-menu-sidenav-content">
        <div class="app-body-container">
          <router-outlet></router-outlet>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>

  </div>
}
